import React, {useState} from 'react';
import backgroundImage from 'src/assets/images/low_res_background_light.png';
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Toolbar,
  Typography,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Tooltip,
  Tabs,
  Tab
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {CloseIcon} from 'yet-another-react-lightbox';
import {
  getLMSResultsData,
  getSearchForm,
  postCourseData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {LoaderDiv} from '@components/card/CardComponentStyles';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import TabsComponent from '../../sub-modules-menu/tabsComponent/TabsComponent';
import {useAppContext} from '@context/AppContext';
import CardAddnotes from './CardAddnotes';
import NewDiscussionDialog from './NewDiscussionDialog';
import NotesList from './Cardcomponent';
import DiscussionList from './DiscussionList';
import {LoadingButton} from '@mui/lab';
import FormConstants from '@shared/constants/FormConstants';
import {
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  LMS_IS_ADMIN,
  LMS_TYPE,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import {useLocation, useNavigate} from 'react-router-dom';
import EncryptUtils from 'src/utils/EncryptUtils';
import PrePostLearning from './Prepostlearning';
import Overviewpage from './opening-Coursecatalog/Overviewpage';
import FeedbackCMS from './FeedbackComponentCMS/FeedbackCMS';
import CreateNewModule from './ModulePageComponents/CreateNewModule';
import ImportModules from './ModulePageComponents/ImportModule';
import ModuleMainPage from './ModulePageComponents/ModuleMainPage';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
import Logo from 'src/minimal-components/logo';
import AccountPopover from 'src/layouts/common/account-popover';
import Settings from './opening-Coursecatalog/Settings';
import AssignMembers from './AssignMembers';
import TabsComponentLMS from '../../sub-modules-menu/tabsComponent/TabsComponentLMS';
import { environment } from '@shared/config/environment';
interface FileToUpload {
  ids: string;
  fileData: string; // Assuming base64-encoded string of the file's data
  fileName: string; // The name of the file
  fileType: string; // The MIME type of the file
  fileError: string;
}
interface WrittenData {
  id: string;
  title: string;
  description: string;
  date: string;
  isFavorited: boolean;
  attachmentName?: FileToUpload[];
}

interface discussionData {
  id: string;
  title: string;
  description: string;
  date: string;
  members: string[];
}
// interface ModulesAdded {
//   id: string;
//   name: string;
//   duration: string;
// }
interface CourseCatalogComponentProps {
  module: string;
  typeselection: any;
}
interface CourseType {
  typecourse: number; // Assuming each type has an ID for key purposes in rendering
  name: string; // Self paced learning or Blended learning
}
interface CourseDetails {
  id: number;
  Title: string;
  RTEContent: string;
  CreatedByName: string;
  course_status: string;
  CourseType: number; // This should match one of the CourseType.CourseType values
}
interface OverviewType {
  courseTypes: CourseType[];
  courseDetails: CourseDetails[];
}

const CourseCatalogComponent = (): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const query = useQuery();
  const section = query.get('section');
  const subsection = query.get('subsection');
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const urlParam = new URLSearchParams(location?.search).get('tk');
  const paramsData = EncryptUtils.getDecryptedParams(urlParam);

  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();
  const {uiFieldsMain, setUiFieldsMain} = useModulePreviewContext();
  const [tabData, setTabData] = React.useState<any>();
  const [loader, setLoader] = React.useState(false);
  const [loaders, setLoaders] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<string>(
    section || 'overview'
  );
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [isclosed, setIsClosed] = React.useState(false);
  const [notes, setnotes] = React.useState<WrittenData[]>([]);
  const [discussion, setDiscussion] = React.useState<discussionData[]>([]);
  const [isloaded, setIsLoaded] = useState(false);
  const [modulecreated, setModulesCreated] = React.useState();
  const {ModulePreviewData, SetModulePreviewData} = useModulePreviewContext();
  const [overviewData, setOverviewData] = React.useState<OverviewType | null>(
    null
  );
  const [moduletypes, setNewModuleType] = React.useState('');
  const [prepost, setprepost] = React.useState(false);
  const [datarecieved, setdatarecieved] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const [uniqueId, setuniqueId] = React.useState(recordId);
  const [type, setType] = React.useState(lmstype);
  const onRoleChange = async (
    item: any,
    unique: string,
    types: any,
    subSection?: string | null
  ) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: unique,
      [LMS_TYPE]: types,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=${item}`;

    if (
      section === 'settings' &&
      subSection &&
      subSection !== 'preview' &&
      subSection !== 'pre_learning_activities' &&
      subSection !== 'post_learning_activities'
    ) {
      url += `&subsection=${subSection}`;
    } else if (
      section === 'Pre_post_learning' &&
      subSection &&
      subSection !== 'preview'
    ) {
      url += `&subsection=${subSection}`;
    }
    if (section === 'module' && subSection === 'preview') {
      url += `&subsection=${subSection}`;
    }
    navigate(url);
  };
  const OverviewFetching = async () => {
    try {
      setLoaders(true);
      const response = await getSearchForm('LMS', 'overview');
      const encryptRequestDatavalue = EncryptUtils.encryptedData(response);

      if (lmstype === 'new' && uniqueId === '') {
        const {sql_data} = response.searchForm.document_getdata_sql;
        const data: any = {
          sql_data: sql_data,
          data: {
            id: uniqueId,
            course_overview_id: uniqueId
          },
          operation: 'INSERT'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        const datacatogory = await postCourseData('LMS', 'CourseType', {
          tk: encryptRequestDatavalue
        });
        setOverviewData({
          courseDetails: result.data,
          courseTypes: datacatogory.courseTypes
        });
        setuniqueId(result.data[0].id || recordId);
        setType('new');
        onRoleChange('overview', result.data[0].id, 'new');
        setdatarecieved(true);
      } else {
        const data = await postCourseData(
          'LMS',
          'CourseType',
          {
            tk: encryptRequestDatavalue,
            values: uniqueId || recordId
          },
          'editOverviewpage'
        );
        setOverviewData(data);
        setuniqueId(recordId);
        setdatarecieved(true);
      }
      if (
        (lmstype === 'edit' || lmstype === 'view') &&
        section === 'overview'
      ) {
        const data = await postCourseData(
          'LMS',
          'CourseType',
          {
            tk: encryptRequestDatavalue,
            values: recordId
          },
          'editOverviewpage'
        );
        setOverviewData(data);
        setuniqueId(recordId);
        setdatarecieved(true);
      }
      if (subsection) {
        setprepost(true);
        onRoleChange(section, recordId, lmstype, subsection);
      }
      setLoaders(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoaders(false);
    }
  };
  function getSearchFormByName(data: {sub_sections: any[]}, tabName: any) {
    const tab = data?.sub_sections?.find(
      (section: {name: any}) => section.name === tabName
    );
    return tab || null;
  }

  const init = async () => {
    try {
      setLoader(true);
      if (uiFieldsMain === null || uiFieldsMain === undefined) {
        const res = await getSearchForm(
          applicationName,
          'course_management_fetch'
        );
        const value = getSearchFormByName(res.searchForm, activeTab);
        setTabData(value);
        setUiFieldsMain(res.searchForm);
      } else {
        const value = getSearchFormByName(uiFieldsMain, activeTab);
        setTabData(value);
        setUiFieldsMain(uiFieldsMain);
      }
      setLoader(false);
      // await OverviewFetching();
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  const getData = async (activeTab: string) => {
    try {
      setIsLoaded(true);
      let res;
      if (activeTab === 'module') {
        res = await getSearchForm(applicationName, activeTab, 'mainPage');
        setTabData(res.searchForm);
      } else {
        res = await getSearchForm(applicationName, activeTab);
        setTabData(res.searchForm);
      }
      if (activeTab === 'module') {
        try {
          if (ModulePreviewData && ModulePreviewData.length > 0) {
            setIsLoaded(false);
            return;
          }
          if (res.searchForm) {
            const {sql_data} = res.searchForm['module_sql'];
            const datavalue = {
              course_overview_id: uniqueId || recordId,
              isAdmin: lmsisAdmin === 'True'
            };
            const data: any = {
              sql_data: sql_data,
              data: datavalue,
              operation: 'SEARCH'
            };
            const encryptRequestData = EncryptUtils.encryptedData(data);
            const result = await getLMSResultsData(applicationName, 'LMS', {
              tk: encryptRequestData
            });
            const processModulesData = (data: any) => {
              return data.map((module: {files: any[]}) => ({
                ...module,
                files:
                  module.files?.map(file => ({
                    ...file,
                    locked_linked_items:
                      typeof file.locked_linked_items === 'string'
                        ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                        : file.locked_linked_items || [],
                    additionalFiles:
                      typeof file.additionalFiles === 'string'
                        ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                        : file.additionalFiles || [] // Keep array or default to empty
                  })) || []
              }));
            };

            // Handling API result
            if (result.data) {
              SetModulePreviewData(processModulesData(result.data));
            }
            // await handleLegacyAppChange();
            setIsLoaded(false);
          }
        } catch (e) {
          const errMessage = getErrorMessage(e);
          enqueueSnackbar(errMessage, SnackBarConfig.getError());
          setIsLoaded(false);
        }
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
  };
  React.useEffect(() => {
    const fetchdata = async () => {
      // setTimeout(async () => {
      await init();
      // }, 100);
    };
    fetchdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // React.useEffect(() => {
  //   if (activeTab === 'overview') {
  //     OverviewFetching();
  //   } else {
  //     getData(activeTab);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeTab]);

  const handleActiveTabChange = (tabName: string) => {
    const value = getSearchFormByName(uiFieldsMain, tabName);
    setTabData(value);
    setActiveTab(tabName);
    onRoleChange(tabName, uniqueId, type, subsection);
  };
  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  const handleEditUser = (data: any) => {
    console.log('Edit user with ID:', data);
  };
  const handleDeleteUser = (data: string) => {
    console.log('Delete user with ID:', data);
  };
  const handleSaveNote = (vals: WrittenData[]) => {
    setnotes((prev: any) => [...prev, ...vals]);
  };
  const handleAddNewRecord = (data: any, module: string) => {
    if (data === 'notes' || data === 'discussion') {
      setIsDialogOpen(true);
    }
    if (module === 'module') {
      setNewModuleType(data);
      setIsDialogOpen(true);
    }
  };
  const handleStartDiscussion = (vals: discussionData[]) => {
    // You can integrate the start discussion logic here
    setDiscussion((prev: any) => [...prev, ...vals]);
  };
  const handleCreateActivity = async () => {
    setprepost(true);
  };
  if (loader)
    return (
      <Stack
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        minHeight={'80vh'}>
        <CircularProgress />
      </Stack>
    );
  const renderActiveTabContent = () => {
    switch (activeTab || section) {
      case 'overview':
        return loaders ? (
          <Stack
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            minHeight={'80vh'}>
            <LoadingScreen />
          </Stack>
        ) : (
          <Overviewpage uiFields={tabData} />
        );
      case 'notes':
        return notes.length !== 0 ? (
          <Container
            sx={{
              marginTop: '2vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '100% !important',
              height: '78vh'
            }}>
            <NotesList notes={notes} setnotes={setnotes} />
          </Container>
        ) : (
          <Container
            sx={{
              display: 'flex',
              marginTop: '2vh',
              justifyContent: 'center',
              flexWrap: 'wrap',
              alignItems: 'center',
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '100% !important',
              height: '78vh'
            }}>
            <div>
              <div>
                <h4>Create a new note in course</h4>
              </div>
              {/* Add your form elements here */}
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  color="info"
                  sx={{
                    mr: '0.8vh'
                  }}
                  onClick={() => handleAddNewRecord('notes', 'notes')}>
                  Add note
                </LoadingButton>
              </div>
            </div>
          </Container>
        );
      case 'discussion':
        return discussion.length !== 0 ? (
          <Container
            sx={{
              marginTop: '2vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '100% !important',
              height: '78vh'
            }}>
            <DiscussionList
              discussion={discussion}
              setDiscussion={setDiscussion}
            />
          </Container>
        ) : (
          <Container
            sx={{
              display: 'flex',
              marginTop: '2vh',
              justifyContent: 'center',
              flexWrap: 'wrap',
              alignItems: 'center',
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '100% !important',
              height: '78vh'
            }}>
            <div>
              <div>
                <h4>Start a discussion in course</h4>
              </div>
              {/* Add your form elements here */}
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  color="info"
                  sx={{
                    mr: '0.8vh'
                  }}
                  onClick={() =>
                    handleAddNewRecord('discussion', 'discussion')
                  }>
                  Start Discussion
                </LoadingButton>
              </div>
            </div>
          </Container>
        );
      case 'feedback':
        return <FeedbackCMS module="feedback" />;
      case 'members':
        return <AssignMembers uiFieldsData={tabData} />;
      case 'Pre_post_learning':
        return (
          tabData !== null &&
          tabData !== undefined && <PrePostLearning uiFieldsdata={tabData} />
          // ) : (
          //   <Container
          //     sx={{
          //       display: 'flex',
          //       justifyContent: 'center',
          //       flexWrap: 'wrap',
          //       alignItems: 'center',
          //       backgroundColor: 'white',
          //       borderRadius: '8px',
          //       maxWidth: '100% !important',
          //       height: '78vh'
          //     }}>
          //     <div>
          //       <div>
          //         <h4>
          //           Create a new pre and post-learning activity in course settings
          //         </h4>
          //       </div>
          //       {/* Add your form elements here */}
          //       <div style={{display: 'flex', justifyContent: 'center'}}>
          //         <LoadingButton
          //           type="submit"
          //           variant="contained"
          //           color="info"
          //           sx={{
          //             mr: '0.8vh'
          //           }}
          //           onClick={handleCreateActivity}>
          //           Create Activity
          //         </LoadingButton>
          //       </div>
          //     </div>
          //   </Container>
        );

      // Add more cases as needed
      case 'module':
        return (
          tabData !== null &&
          tabData !== undefined && (
            <Container
              sx={{
                marginTop: '2vh',
                borderRadius: '8px',
                maxWidth: '100% !important'
              }}>
              {/* <ModulePreviewContextProvider moduledata={modulecreated}> */}
              <ModuleMainPage
                uiFields={tabData}
                moduledata={ModulePreviewData}
                isDialogopen={isDialogOpen}
                // fetchData={isclosed}
                // handleClick={() => setIsClosed(false)}
                handleAddNewRecord={handleAddNewRecord}
              />
              {/* </ModulePreviewContextProvider> */}
            </Container>
          )
        );
      // if (!isloaded) {
      //   return ModulePreviewData ? (
      //     <Container
      //       sx={{
      //         marginTop: '2vh',
      //         borderRadius: '8px',
      //         maxWidth: '100% !important'
      //       }}>
      //       {/* <ModulePreviewContextProvider moduledata={modulecreated}> */}
      //       <ModuleMainPage
      //         uiFields={uiFields}
      //         moduledata={ModulePreviewData}
      //         isDialogopen={isDialogOpen}
      //         // fetchData={isclosed}
      //         // handleClick={() => setIsClosed(false)}
      //         handleAddNewRecord={handleAddNewRecord}
      //       />
      //       {/* </ModulePreviewContextProvider> */}
      //     </Container>
      //   ) : (
      //     <Container
      //       sx={{
      //         display: 'flex',
      //         marginTop: '2vh',
      //         justifyContent: 'center',
      //         flexWrap: 'wrap',
      //         alignItems: 'center',
      //         backgroundColor: 'white',
      //         borderRadius: '8px',
      //         maxWidth: '100% !important',
      //         height: '71vh'
      //       }}>
      //       <div>
      //         <div>
      //           <Stack
      //             spacing={3}
      //             alignItems="center"
      //             justifyContent="center"
      //             flexWrap="wrap">
      //             <Stack spacing={1} sx={{textAlign: 'center'}}>
      //               <Typography
      //                 variant="body1"
      //                 sx={{
      //                   color: 'text.secondary',
      //                   maxWidth: '55vh',
      //                   fontSize: '20px !important'
      //                 }}>
      //                 To get started, create a
      //                 <Box
      //                   component="span"
      //                   onClick={() =>
      //                     handleAddNewRecord('Add module', 'module')
      //                   }
      //                   sx={{
      //                     mx: 0.5,
      //                     color: 'primary.main',
      //                     cursor: 'pointer'
      //                   }}>
      //                   new module
      //                 </Box>
      //               </Typography>
      //             </Stack>
      //           </Stack>
      //         </div>
      //         {/* Add your form elements here */}
      //       </div>
      //     </Container>
      //   );
      // } else {
      //   return (
      //     <Stack
      //       display={'flex'}
      //       justifyContent={'center'}
      //       alignItems={'center'}
      //       minHeight={'50vh'}>
      //       <LoadingScreen />
      //     </Stack>
      //   );
      // }
      case 'settings':
        return (
          tabData !== null &&
          tabData !== undefined && <Settings uiFieldsData={tabData} />
        );
    }
  };
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
      }}>
      <Logo
        disabledLink={false}
        applicationName={'LMS'}
        sx={{mt: 0, ml: 0, mb: 0}}
      />

      <Box>
       {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED && <AccountPopover isDashboard={true} />}
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              navigate(
                `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}`,
                {
                  state: {}
                }
              );
            }}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        backgroundImage: `${!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED && 'url(${backgroundImage})'}`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundAttachment: 'fixed'
      }}>
      <Toolbar
        sx={{
          height: 1,
          backgroundColor: 'white'
          // px: {lg: 5}
        }}>
        {renderContent}
      </Toolbar>
      <Box sx={{display: 'flex'}}>
        {uiFieldsMain && Object.keys(uiFieldsMain).length > 0 ? (
          <Box sx={{m: 2, display: 'flex', flex: '1', flexDirection: 'column'}}>
            <TabsComponentLMS
              sectionUIData={uiFieldsMain}
              sectionRowsData={[]}
              module="course_management"
              handleEditUser={handleEditUser}
              handleDeleteUser={handleDeleteUser}
              handleAddNewCMSRecord={handleAddNewRecord}
              handleActiveTabChange={handleActiveTabChange}
            />
            {/* <Box sx={{width: '100%'}}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                spacing={2}>
                <Grid item xs={12}>
                  <Tabs
                    value={activeTab}
                    variant="fullWidth"
                    textColor="primary"
                    sx={{
                      backgroundColor: '#F4F6F8',
                      '& .MuiTab-root': {
                        fontSize: '16px',
                        fontWeight: '500',
                        '&:hover': {
                          backgroundColor: '#e0e0e0', // Change background on hover
                          borderRadius: 2
                        }
                      },
                      '& .MuiTab-root.Mui-selected': {
                        color: 'primary.main',
                        margin: 1,
                        backgroundColor: 'white',
                        borderRadius: 2
                      },
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#637381',
                        height: 0
                      }
                    }}>
                    <Tab label="Basic Info" />
                    <Tab label="Lock Properties" />
                    <Tab label="Resources" />
                  </Tabs>
                </Grid>
              </Grid>
            </Box> */}
            {renderActiveTabContent()}
            {activeTab === 'notes' && (
              <CardAddnotes
                open={isDialogOpen}
                title="Add Note"
                onClose={handleDialogClose}
                onCreate={isDialogOpen}
                onSave={handleSaveNote}
              />
            )}
            {activeTab === 'discussion' && (
              <NewDiscussionDialog
                open={isDialogOpen}
                onClose={handleDialogClose}
                onStartDiscussion={handleStartDiscussion}
              />
            )}
            {activeTab === 'module' && moduletypes === 'Add module' && (
              <CreateNewModule
                uiFieldsdata={
                  tabData?.searchForm?.create_module_json
                    ? tabData?.searchForm?.create_module_json
                    : undefined
                }
                open={isDialogOpen}
                onClose={handleDialogClose}
                title="New Module"
                operation="INSERT"
              />
            )}
            {activeTab === 'module' && moduletypes === 'Import' && (
              <ImportModules
                open={isDialogOpen}
                onClose={handleDialogClose}
                title="Import Module"
              />
            )}
          </Box>
        ) : (
          <Box sx={{m: 4, display: 'flex', flex: '1', alignItem: 'center'}}>
            <LoaderDiv>
              <CircularProgress />
            </LoaderDiv>
          </Box>
        )}
        {/* <Box sx={{m: 4}}>
          <LoaderDiv>
            <CircularProgress />
          </LoaderDiv>
        </Box> */}
      </Box>
    </Box>
  );
};

export default CourseCatalogComponent;

